module.exports = __webpack_public_path__ + "img/symposium_login.99b419d0.png";